<template>
  <v-container>
    <v-dialog v-model="dialogEditPassword" max-width="600px">
      <v-card>
        <v-card-title>Actualizar contraseña</v-card-title>
        <div style="margin: 16px">
          <v-form ref="formPassword">
            <v-text-field
              v-model="passwordData.oldPassword"
              label="Contraseña actual"
              outlined
              :rules="[() => !!passwordData.oldPassword || 'Campo requerido']"
              type="password"
            ></v-text-field>
            <v-text-field
              v-model="passwordData.newPassword"
              label="Contraseña nueva"
              outlined
              :rules="[() => !!passwordData.newPassword || 'Campo requerido']"
              type="password"
            ></v-text-field>
          </v-form>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogEditPassword = false">Cancelar</v-btn>
          <v-btn color="primary" @click="updatePassword">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditContactInfo" max-width="600px">
      <v-card>
        <v-card-title>Actualizar datos de contacto</v-card-title>
        <div style="margin: 16px">
          <v-text-field
            v-model="patientSelected.email"
            label="Email"
            outlined
            :rules="[() => !!patientSelected.email || 'Campo requerido']"
            type="email"
          ></v-text-field>

          <v-text-field
            v-model="patientSelected.phoneNumber"
            label="Teléfono"
            outlined
            :rules="[() => !!patientSelected.phoneNumber || 'Campo requerido']"
          ></v-text-field>

          <v-select
            v-model="patientSelected.preferredHourType"
            :items="[
              { text: 'Fonasa', value: 'fonasa' },
              { text: 'Particular / Isapre', value: 'particular' }
            ]"
            label="Tipo de hora preferido"
            outlined
            clearable
            hint="Selecciona tu tipo de hora para facilitar futuras reservas"
            persistent-hint
          ></v-select>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogEditContactInfo = false">Cancelar</v-btn>
          <v-btn color="primary" @click="updateContactInfo">Actualizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditPasswordSuccess" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">Contraseña actualizada correctamente</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogEditPasswordSuccess = false"
            color="primary"
            class="container"
          >Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditPasswordError" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">No se ha podido actualizar la contraseña</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogEditPasswordError = false;" color="primary" class="container">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEditContactInfoSuccess" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="success" />
          <p class="font-weight-medium text-center title">Información actualizada correctamente</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogEditContactInfoSuccess = false"
            color="primary"
            class="container"
          >Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogEditContactInfoError" persistent max-width="600">
      <v-card>
        <div class="d-flex flex-column align-items-center pa-4">
          <sweetalert-icon icon="error" />
          <p class="font-weight-medium text-center title">No se ha podido actualizar la información</p>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="dialogEditContactInfoError = false;"
            color="primary"
            class="container"
          >Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="d-flex justify-center mt-6 mb-10">
      <v-avatar class="mb-4 ma-4" color="primary" size="70">
        <v-icon color="white" size="40">person</v-icon>
      </v-avatar>
    </div>
    <v-list>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Nombre</v-list-item-title>
          <v-list-item-subtitle>{{accountData.fullName}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Correo electrónico</v-list-item-title>
          <v-list-item-subtitle>{{accountData.email}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Teléfono</v-list-item-title>
          <v-list-item-subtitle>{{accountData.phoneNumber}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>Tipo de hora preferido</v-list-item-title>
          <v-list-item-subtitle>{{preferredHourTypeName || 'No seleccionado'}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div class="d-flex flex-column flex-sm-row justify-center">
      <v-btn
        @click="dialogEditContactInfo = true"
        color="primary"
        text
        class="mt-4 mr-2"
      >Actualizar contacto</v-btn>
      <v-btn
        @click="dialogEditPassword = true"
        color="primary"
        text
        class="mt-4 ml-2"
      >Actualizar contraseña</v-btn>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "MyAccount",
  props: {
    msg: String
  },
  data: () => ({
    accountData: {},
    patientSelected: {},
    passwordData: {},
    dialogEditContactInfo: false,
    dialogEditPassword: false,
    dialogEditPasswordSuccess: false,
    dialogEditPasswordError: false,
    dialogEditContactInfoSuccess: false,
    dialogEditContactInfoError: false
  }),
  computed: {
    preferredHourTypeName() {
      if (!this.accountData.preferredHourType) return 'No seleccionado';
      return this.accountData.preferredHourType === 'fonasa' ? 'Fonasa' : 'Particular / Isapre';
    }
  },
  methods: {
    updateContactInfo: function() {
      this.dialogEditContactInfo = false;
      const axios = require("axios");
      axios
        .post("updateContactInfo", {
          patientData: {
            email: this.patientSelected.email,
            phoneNumber: this.patientSelected.phoneNumber,
            preferredHourType: this.patientSelected.preferredHourType
          }
        })
        .then(
          res => {
            this.dialogEditContactInfoSuccess = true;
            this.accountData = { ...this.accountData, ...this.patientSelected };
            // Actualizar el store con el nuevo tipo de hora
            this.$store.dispatch('commitUser', this.accountData);
          },
          err => {
            this.dialogEditContactInfoError = true;
            console.log(err);
          }
        );
    },
    async updatePassword() {
      this.dialogEditPassword = false;
      try {
        const axios = require("axios");
        await axios.post("updatePassword", {
          passwordData: this.passwordData
        });
        this.dialogEditPasswordSuccess = true;
      } catch (err) {
        this.dialogEditPasswordError = true;
      }
      this.$refs.formPassword.reset();
    }
  },
  mounted: function() {
    const axios = require("axios");

    // Cargar datos de cuenta
    axios.get("getMyAccountData").then(
      res => {
        this.accountData = res.data;
        this.patientSelected = { ...res.data };
      },
      err => {
        console.log(err);
      }
    );
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
